
export default {
  name: "CardItem",
  props: ["cardContainerStyle", "cardItemTitle"],
};
